// extracted by mini-css-extract-plugin
export var logo = "header-module--logo--mTLiM";
export var menu = "header-module--menu--Tzp5Z";
export var part = "header-module--part--8i5Et";
export var phone = "header-module--phone--0J2Tj";
export var rightBottom = "header-module--rightBottom--toB1V";
export var root = "header-module--root--KGdif";